import type { MetaInfo } from 'vue-meta';
import { buildSeoHead } from '~/helpers/buildSeoHead';

type AnalysisPageMetaInfoInput = {
  page: any;
  isListPage?: boolean;
  isNoIndex?: boolean;
  packageName?: string;
};

export const getAnalysisPageMetaInfo = ({ page, isListPage, isNoIndex, packageName }: AnalysisPageMetaInfoInput): MetaInfo => {
  if (packageName) {
    const analysisName = isListPage ? 'Analyslista' : page?.meta_title || page?.title || page?.name;
    return buildSeoHead({
      title: `${packageName} | ${analysisName}`,
      description: `${packageName} ${analysisName}`,
      keywords: `${packageName}, ${analysisName}`,
      isNoIndex,
    });
  }

  if (isListPage) {
    return buildSeoHead({
      title: 'Analyslista',
      description: 'Analyslista',
      keywords: 'Analyslista',
      isNoIndex,
    });
  }

  if (!page) {
    return null;
  }

  return buildSeoHead({
    title: page?.meta_title || page?.title || page?.name,
    description: page?.meta_description,
    keywords: page?.meta_keyword || page?.meta_keywords,
    isNoIndex,
  });
};
